let mode = 'normal'

function isImpersonationPath(pathname) {
  return /(^|\/)(signin_as|login-as)(\/|$)/.test(pathname)
}

export function initializeAuthModeFromLocation(pathname = window.location.pathname) {
  mode = isImpersonationPath(pathname) ? 'impersonation' : 'normal'
  return mode
}

export function setAuthMode(nextMode) {
  mode = nextMode
}

export function getAuthMode() {
  return mode
}
